<template>
  <div>
    <!-- Modal Loading -->
    <v-dialog persistent max-width="300" v-model="blockScreen">
      <v-card class="px-3 py-5 text-center">
        <div class="text-center pb-5">
          <span class="title font-weight-bold"
            >Aguarde, estamos contratando a assinatura ...</span
          >
        </div>
        <v-progress-circular
          :size="70"
          :width="7"
          class="checkin-text"
          indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
    <v-card class="pa-3">
      <v-layout column style="padding: 10px;">
        <v-layout
          px-3
          row
          align-center
          justify-space-between
          style="margin-bottom: 10px;"
        >
          <span class="title">Venda de Assinaturas</span>
        </v-layout>

        <v-flex xs12 md3 style="margin-bottom: 10px;">
          <BuscaUsuario @selectUser="onSelectedUser"></BuscaUsuario>
        </v-flex>

        <v-flex xs12 md3>
          <v-autocomplete
            v-model="clientModel"
            :items="clientItems"
            :loading="isLoadingClient"
            color="blue darken-4"
            hide-no-data
            hide-selected
            item-text="name"
            item-value="id"
            label="Cliente"
            placeholder="Digite o nome para buscar o cliente"
            return-object
          ></v-autocomplete>
        </v-flex>

        <v-flex xs12 md3>
          <v-select
            v-model="promotionModel"
            :items="promotionItems"
            :loading="isLoadingPromotion"
            color="blue darken-4"
            hide-no-data
            item-text="name"
            item-value="id"
            label="Pacote de assinatura"
            required
            @change="onPromotionChanged"
            placeholder="Selecione o pacote de assinatura"
            return-object
          ></v-select>
        </v-flex>

        <v-layout pt-3 align-center>
          <v-flex xs12 md3 style="margin-right: 20px;">
            <label for="model">Preço da Ativação:</label>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1">R$</span>
              </div>
              <money
                v-model="activation_price"
                v-bind="money"
                class="form-control"
              ></money>
            </div>
          </v-flex>
          <v-flex xs12 md3>
            <label for="model">Preço da Recorrência:</label>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1">R$</span>
              </div>
              <money
                v-model="recurrency_price"
                v-bind="money"
                class="form-control"
              ></money>
            </div>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs12 md3 style="margin-top: 20px;">
            <v-select
              v-model="creditCardModel"
              :items="creditCardItems"
              :loading="isLoadingCreditCard"
              color="blue darken-4"
              hide-no-data
              item-text="nickname"
              item-value="id"
              label="Método de pagamento"
              required
              placeholder="Selecione o cartão de crédito"
              return-object
            ></v-select>
          </v-flex>
        </v-layout>

        <v-layout pt-3 align-center style="margin-top: 20px;">
          <v-btn class="success ma-0" @click="onContratarAssinaturaClicked">
            <span class="white--text">Contratar assinatura</span>
          </v-btn>
        </v-layout>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import BuscaUsuario from '../shared/BuscaUsuario.vue';
import ClientController from '../../controllers/ClientController.js';
import PromotionController from '../../controllers/PromotionController.js';
import CreditCardController from '../../controllers/UserCreditCardController';

import NumberHelper from '../../helpers/NumberHelper';

export default {
  components: {
    BuscaUsuario,
  },
  created() {
    this.clientController = new ClientController(this.$resource);
    this.promotionController = new PromotionController(this.$resource);
    this.creditCardController = new CreditCardController(this.$resource);

    this.getAllClients();
  },
  data() {
    return {
      activation_price: 0,
      recurrency_price: 0,
      selected_promotion_id: null,

      clients: [],
      promotions: [],
      creditCards: [],

      assinaturaModel: {},
      clientModel: {},
      userModel: {},
      promotionModel: {},
      creditCardModel: {},

      blockScreen: false,
      isLoadingClient: false,
      isLoadingPromotion: false,
      isLoadingCreditCard: false,

      money: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: true,
      },
    };
  },
  props: {},
  methods: {
    async getAllClients() {
      try {
        if (this.isLoadingClient) return;

        this.isLoadingClient = true;
        this.clients = await this.clientController.getAllClientsTypeCondominio();
      } catch (error) {
        return this.$awn.alert('Erro ao obter clientes');
      } finally {
        this.isLoadingClient = false;
      }
    },
    async getAllRecurrentPackage(clientId) {
      try {
        if (this.isLoadingPromotion) return;

        this.isLoadingPromotion = true;
        this.promotions = await this.promotionController.getAllRecurrentTypeByClient(
          clientId
        );
      } catch (error) {
        return this.$awn.alert('Erro ao obter pacotes');
      } finally {
        this.isLoadingPromotion = false;
      }
    },
    async getAllUserCreditCard(userId) {
      try {
        if (this.isLoadingCreditCard) return;

        this.isLoadingCreditCard = true;
        this.creditCards = await this.creditCardController.getAllByUserId(
          userId,
          true
        );
      } catch (error) {
        return this.$awn.alert('Erro ao obter cartões');
      } finally {
        this.isLoadingCreditCard = false;
      }
    },
    async onPromotionChanged() {
      this.selected_promotion_id = this.promotionModel.id;
      this.activation_price = this.promotionModel.activation_price / 100;
      this.recurrency_price = this.promotionModel.recurrency_price / 100;
    },
    async onSelectedUser(value) {
      this.userModel = value;
      let clienteSelecionado = this.clients.filter(
        v => v.id == value.clientUser_client_id
      );

      this.clientModel = {};
      if (clienteSelecionado.length > 0) {
        this.clientModel = clienteSelecionado[0];
        this.getAllRecurrentPackage(value.clientUser_client_id);
        this.getAllUserCreditCard(value.id);
      }
    },
    async onContratarAssinaturaClicked() {
      this.blockScreen = true;
      try {
        if (
          this.userModel.id == null ||
          this.clientModel.id == null ||
          this.promotionModel.id == null ||
          this.creditCardModel.id == null
        ) {
          this.$awn.alert('Preencha os campos obrigatórios!');
        } else {
          let activationValue = NumberHelper.convertMoneyToInteger(
            String(this.activation_price)
          );
          let recurrencyValue = NumberHelper.convertMoneyToInteger(
            String(this.recurrency_price)
          );

          let data = {
            userId: this.userModel.id,
            clientId: this.clientModel.id,
            promotionId: this.selected_promotion_id,
            activationValue: activationValue,
            recurrencyValue: recurrencyValue,
            userCreditCardId: this.creditCardModel.id,
          };

          await this.promotionController
            .subscribeRecurrentAdm(data)
            .then(value => {
              this.$awn.success('Reserva realizada com sucesso.');
              this.clearFields();
            })
            .catch(error => {
              this.$awn.alert(`${error.body.message}`);
              this.clearFields();
            });
        }
      } catch (error) {
        this.$awn.alert(`${error.message}`);
      } finally {
        this.blockScreen = false;
      }    
    },
    async clearFields() {
      this.clientModel = {};
      this.userModel = {};
      this.assinaturaModel = {};
      this.promotionModel = {};
      this.creditCardModel = {};
      this.clients = [];
      this.promotions = [];
      this.creditCards = [];
      this.activation_price = 0;
      this.recurrency_price = 0;
    },
  },
  filters: {
    formatPrice(price) {
      return NumberHelper.centsToReal(price);
    },
  },
  computed: {
    clientItems() {
      return this.clients.map(client => {
        return {
          id: client.id,
          name: client.name,
        };
      });
    },
    promotionItems() {
      return this.promotions.map(promotion => {
        return {
          id: promotion.id,
          name: promotion.name,
          activation_price: promotion.activation_price,
          recurrency_price: promotion.recurrency_price,
          price_km: promotion.price_km,
        };
      });
    },
    creditCardItems() {
      return this.creditCards.map(creditCard => {
        return {
          id: creditCard.id,
          nickname: creditCard.nickname,
        };
      });
    },
  },
};
</script>

<style scoped>
.inputs {
  border: 1px solid grey;
  border-radius: 3px;
}

.inputs >>> #inputDate {
  width: 100%;
  text-align: center;
}
</style>
